import { useEffect, useRef } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/i18n/LanguageContext";
import { Navbar } from "@/components/Navbar";
import { KineticHero } from "@/components/KineticHero";
import { EditorialRibbon } from "@/components/EditorialRibbon";
import { ManifestoChapters } from "@/components/ManifestoChapters";
import { ProgramsCatalog } from "@/components/ProgramsCatalog";
import { ProjectShowcase } from "@/components/ProjectShowcase";
import { CareerReadiness } from "@/components/CareerReadiness";
import { Community } from "@/components/Community";
import { EnrollmentForm } from "@/components/EnrollmentForm";
import { Footer } from "@/components/Footer";
import { AIAssistant } from "@/components/AIAssistant";

function App() {
  const chatRef = useRef(null);
  const openChat = () => chatRef.current?.open();

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <LanguageProvider>
      <div className="min-h-screen bg-[#FAF7F2] text-[#17181A] antialiased">
        <Navbar />
        <main>
          <KineticHero onOpenChat={openChat} />
          <EditorialRibbon />
          <ManifestoChapters />
          <ProgramsCatalog />
          <ProjectShowcase />
          <CareerReadiness onOpenChat={openChat} />
          <Community />
          <EnrollmentForm />
        </main>
        <Footer />
        <AIAssistant ref={chatRef} />
        <Toaster position="top-center" richColors />
      </div>
    </LanguageProvider>
  );
}

export default App;
